// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import NormalGameManager from "../../../manager/NormalGameManager";
const {ccclass, property} = cc._decorator;

@ccclass
export default class SuperPowerSelect7 extends BasePopUpLayer {
   
    
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        cc.tween(this.node)
        .delay(2)
        .call(this.onClickConfirm.bind(this))
        .start();
    }

    onClickConfirm() {
        this.destroyNode();
        this._carryData.parent.showEndUI('就这样啦，我们下次再会');
        
        NormalGameManager._instance.addDelayTimeEvent('37', 1);
    }

    // update (dt) {}
}
